export reducer from './reducer';
export * as actions from './actions';

export ArticleModal from './components/ArticleModal';



/** WEBPACK FOOTER **
 ** ./src/app/modules/modal/index.js
 **/